import React, { useCallback } from 'react'
import MatrixTypeAnswer from '../MatrixTypeAnswer/MatrixTypeAnswer'
import MultipleChoiceMultipleChoiceAnswer from '../MutipleChoiceMutipleChoiceAnswer/MultipleChoiceAnswer'
import SingleChoiceMultipleChoiceAnswer from '../SingleChoiceMultipleChoiceAnswer/SingleChoiceMultipleChoiceAnswer'
import NumericalTypeAnswer from '../NumericalTypeAnswer/NumericalTypeAnswer'
import { withRouter } from 'react-router'
import { FETCH_QUESTION_SET } from '../../constants/actionTypes'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import Api from '../../data'
import './Answer.css'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

const mapDispatchToProps = (dispatch) => ({
    onQuestionLoad: (payload) => {
        return new Promise((resolve, reject) => {
            dispatch({ type: FETCH_QUESTION_SET, payload })
            resolve()
        })
    },
})

const mapStateToProps = (state) => ({
    queryparam: state.queryparam,
    instructions: state.instructions,
    mock_test_submit: state.mock_test_submit,
    testStatus: state.testStatus,
    testData: state.testpanel,
})
const Answer = (props) => {
    function logEvents(questionData, ans) {
        trackEvent(
            EVENT_NAMES.TAP_ANSWERED_WEB,
            'User taps on any option or writes answer for any question',
            {
                [ANALYTICS_KEYS.SUCCESS]: true,
                [ANALYTICS_KEYS.QUESTION_ID]: questionData.question.questionid,
                [ANALYTICS_KEYS.QUESTION_TYPE]: questionData.question.questionType,
                [ANALYTICS_KEYS.OPTIONS_SELECTED]: ans,
            },
        )
    }
    const handleSingleChoiceAnswers = useCallback(
        (ans, questionData) => {
            if (props.isPreview) return

            logEvents(questionData, ans)
            let activityType = 'Answered'
            const debouncedSave = debounce(() => {
                let d = [...props.testData.questionset]
                for (let i = 0; i < d.length; i++) {
                    if (d[i].subject === props.subject) {
                        for (let j = 0; j < d[i].questionList.length; j++) {
                            if (
                                d[i].questionList[j].question.questionid ===
                                questionData.question.questionid
                            ) {
                                if (ans === '') {
                                    d[i].questionList[j].question.answerbyUser = ['']
                                    d[i].questionList[j].question.isAnswered =
                                        props.mock_test_submit === true
                                            ? true
                                            : false
                                    activityType = 'Reset_Single_option'
                                } else if (
                                    d[i].questionList[j].question.answerbyUser[0] ===
                                    ans
                                ) {
                                    d[i].questionList[j].question.answerbyUser = ['']
                                    d[i].questionList[j].question.isAnswered = false
                                    activityType = 'Reset_Single_option'
                                } else {
                                    d[i].questionList[j].question.answerbyUser = [
                                        ans,
                                    ]
                                    d[i].questionList[j].question.isVisited = true
                                    d[i].questionList[j].question.isAnswered = true
                                }
                            }
                        }
                    }
                }
                props.calculateTimeSpent(
                    questionData.question.questionid,
                    d,
                    false,
                    false,
                )
                props.onQuestionLoad(d).then(() => {
                    Api.updateQuestion(
                        props,
                        d,
                        questionData.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }, 0)
            debouncedSave()
        },
        [props.testData],
    )

    const handleNumericalAnswers = useCallback(
        (ans, questionData) => {
            if (props.isPreview) return

            logEvents(questionData, ans)
            let activityType = 'Answered'
            const debouncedSave = debounce(() => {
                let d = [...props.testData.questionset]
                for (let i = 0; i < d.length; i++) {
                    if (d[i].subject === props.subject) {
                        for (let j = 0; j < d[i].questionList.length; j++) {
                            if (
                                d[i].questionList[j].question.questionid ===
                                questionData.question.questionid
                            ) {
                                if (ans === '') {
                                    d[i].questionList[j].question.answerbyUser = ['']
                                    d[i].questionList[j].question.isAnswered = false
                                    activityType = 'Reset_Single_option'
                                } else if (
                                    d[i].questionList[j].question.answerbyUser[0] ===
                                    ans
                                ) {
                                    d[i].questionList[j].question.answerbyUser = ['']
                                    d[i].questionList[j].question.isAnswered = false
                                    activityType = 'Reset_Single_option'
                                } else {
                                    d[i].questionList[j].question.answerbyUser = [
                                        ans,
                                    ]
                                    d[i].questionList[j].question.isVisited = true
                                    d[i].questionList[j].question.isAnswered = true
                                }
                            }
                        }
                    }
                }
                props.calculateTimeSpent(
                    questionData.question.questionid,
                    d,
                    false,
                    false,
                )
                props.onQuestionLoad(d).then(() => {
                    Api.updateQuestion(
                        props,
                        d,
                        questionData.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }, 0)
            debouncedSave()
        },
        [props.testData],
    )

    const handleMatrixAnswers = useCallback(
        (ans, questionData) => {
            if (props.isPreview) return

            logEvents(questionData, ans)
            let activityType = 'Answered'

            const debouncedSave = debounce(() => {
                let d = [...props.testData.questionset]
                for (let i = 0; i < d.length; i++) {
                    if (d[i].subject === props.subject) {
                        for (let j = 0; j < d[i].questionList.length; j++) {
                            if (
                                d[i].questionList[j].question.questionid ===
                                questionData.question.questionid
                            ) {
                                if (
                                    Array.isArray(
                                        d[i].questionList[j].question.answerbyUser,
                                    )
                                ) {
                                    if (
                                        d[i].questionList[
                                            j
                                        ].question.answerbyUser.includes(ans)
                                    ) {
                                        let index =
                                            d[i].questionList[
                                                j
                                            ].question.answerbyUser.indexOf(ans)
                                        let cl =
                                            d[i].questionList[j].question
                                                .answerbyUser
                                        cl.splice(index, 1)
                                        d[i].questionList[j].question.answerbyUser =
                                            cl
                                        activityType = 'Reset_Single_option'
                                        if (cl.length === 0) {
                                            d[i].questionList[
                                                j
                                            ].question.isVisited = true
                                            d[i].questionList[
                                                j
                                            ].question.isAnswered = false
                                            activityType = 'Reset_Single_option'
                                        }
                                    } else {
                                        let cl =
                                            d[i].questionList[j].question
                                                .answerbyUser
                                        cl.push(ans)
                                        d[i].questionList[j].question.answerbyUser =
                                            cl
                                        d[i].questionList[
                                            j
                                        ].question.isVisited = true
                                        d[i].questionList[
                                            j
                                        ].question.isAnswered = true
                                    }
                                } else {
                                    let cl = []
                                    cl.push(ans)
                                    d[i].questionList[j].question.answerbyUser = cl
                                    d[i].questionList[j].question.isVisited = true
                                    d[i].questionList[j].question.isAnswered = true
                                }
                            }
                        }
                    }
                }

                props.calculateTimeSpent(
                    questionData.question.questionid,
                    d,
                    false,
                    false,
                )
                props.onQuestionLoad(d).then(() => {
                    Api.updateQuestion(
                        props,
                        d,
                        questionData.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }, 200)
            debouncedSave()
        },
        [props.testData],
    )

    const handleMCQAnswers = useCallback(
        (ans, questionData) => {
            if (props.isPreview) return

            logEvents(questionData, ans)
            let activityType = 'Answered'

            const debouncedSave = debounce(() => {
                let d = [...props.testData.questionset]
                for (let i = 0; i < d.length; i++) {
                    if (d[i].subject === props.subject) {
                        for (let j = 0; j < d[i].questionList.length; j++) {
                            if (
                                d[i].questionList[j].question.questionid ===
                                questionData.question.questionid
                            ) {
                                if (
                                    Array.isArray(
                                        d[i].questionList[j].question.answerbyUser,
                                    )
                                ) {
                                    if (
                                        d[i].questionList[
                                            j
                                        ].question.answerbyUser.includes(ans)
                                    ) {
                                        let index =
                                            d[i].questionList[
                                                j
                                            ].question.answerbyUser.indexOf(ans)
                                        let cl =
                                            d[i].questionList[j].question
                                                .answerbyUser
                                        cl.splice(index, 1)
                                        activityType = 'Reset_Single_option'
                                        d[i].questionList[j].question.answerbyUser =
                                            cl
                                        if (cl.length === 0) {
                                            d[i].questionList[
                                                j
                                            ].question.isAnswered = false
                                            activityType = 'Reset_Single_option'
                                        }
                                    } else {
                                        let cl =
                                            d[i].questionList[j].question
                                                .answerbyUser
                                        cl.push(ans)
                                        d[i].questionList[j].question.answerbyUser =
                                            cl
                                        d[i].questionList[
                                            j
                                        ].question.isAnswered = true
                                    }
                                } else {
                                    let cl = []
                                    cl.push(ans)
                                    d[i].questionList[j].question.answerbyUser = cl
                                    d[i].questionList[j].question.isVisited = true
                                    d[i].questionList[j].question.isAnswered = true
                                }
                            }
                        }
                    }
                }
                props.calculateTimeSpent(
                    questionData.question.questionid,
                    d,
                    false,
                    false,
                )
                props.onQuestionLoad(d).then(() => {
                    Api.updateQuestion(
                        props,
                        d,
                        questionData.question.questionid,
                        activityType,
                    ).catch((error) => {
                        console.log(error)
                    })
                    props.setDisconnectTime(props.queryparam.disconnect_time * 60)
                })
            }, 0)
            debouncedSave()
        },
        [props.testData],
    )

    if (props.answerType === 'MATRIX') {
        return (
            <div className="answer">
                <MatrixTypeAnswer
                    isPreview={props.isPreview}
                    getAppendImgUrl={props.getAppendImgUrl}
                    data={props.answerData}
                    subject={props.subject}
                    mock={props.mock_test_submit}
                    onClick={handleMatrixAnswers}
                    queryparam={props.queryparam}
                />
            </div>
        )
    }
    if (props.answerType === 'SCMCQ') {
        return (
            <div className="answer">
                <SingleChoiceMultipleChoiceAnswer
                    isPreview={props.isPreview}
                    getAppendImgUrl={props.getAppendImgUrl}
                    data={props.answerData}
                    subject={props.subject}
                    mock={props.mock_test_submit}
                    onClick={handleSingleChoiceAnswers}
                    queryparam={props.queryparam}
                />
            </div>
        )
    }
    if (props.answerType === 'MCMCQ') {
        return (
            <div className="answer">
                <MultipleChoiceMultipleChoiceAnswer
                    isPreview={props.isPreview}
                    getAppendImgUrl={props.getAppendImgUrl}
                    data={props.answerData}
                    subject={props.subject}
                    mock={props.mock_test_submit}
                    onClick={handleMCQAnswers}
                    queryparam={props.queryparam}
                />
            </div>
        )
    }
    if (props.answerType === 'SAN' || props.answerType === 'SAT') {
        return (
            <div className="answer">
                <NumericalTypeAnswer
                    isPreview={props.isPreview}
                    getAppendImgUrl={props.getAppendImgUrl}
                    data={props.answerData}
                    subject={props.subject}
                    type={props.answerType}
                    mock={props.mock_test_submit}
                    onClick={handleNumericalAnswers}
                    queryparam={props.queryparam}
                />
            </div>
        )
    }
    return null
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Answer))
